module.exports = __webpack_public_path__ + "media/images/icons/lets-talk-ce7a9082f5da082b70956b9d50775269.svg";